var map = {
	"./adult/nn/6 1 Ordforstaelse Intro.mp3": 823,
	"./adult/no/6 1 Ordforstaelse Intro.mp3": 824,
	"./child/de/6 1 Ordforstaelse Intro.mp3": 825,
	"./youth/de/6 1 Ordforstaelse Intro.mp3": 826,
	"./youth/nn/6 1 Ordforstaelse Intro.mp3": 827,
	"./youth/no/6 1 Ordforstaelse Intro.mp3": 828,
	"./youth/se/6 1 Ordforstaelse Intro.mp3": 829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 822;